// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dashboard-container {
  height: calc(100vh - 80px);
  overflow: auto;
}
#dashboard-container .card-block {
  position: relative;
  cursor: pointer;
  border: 1px solid var(--dee3);
}
#dashboard-container .card-block .bottom-line {
  padding: 8px 0px 0px 0px;
  background-color: var(--56ff);
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-radius: 0px 0px 35px 35px;
  visibility: hidden;
}
#dashboard-container .card-block:hover {
  border: 1px solid var(--56ff);
  box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.0392156863);
}
#dashboard-container .card-block:hover .bottom-line {
  visibility: visible;
}

.react-tooltip {
  z-index: 999;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 9px 29px;
  background-color: var(--ffff) !important;
  color: var(--2749) !important;
  opacity: 1;
  border: 1px solid #efefef;
  max-width: 350px !important;
  padding: 16px !important;
  border-radius: 10px !important;
}

.react-tooltip-arrow {
  display: none;
}

.core-styles-module_show__Nt9eE {
  opacity: 1 !important;
}

.switch-block:hover .react-tooltip {
  animation-name: zoomIn;
  animation-duration: 0.3s;
  animation-fill-mode: both;
}

#dashboard-container-dark {
  height: calc(100vh - 80px);
  overflow: auto;
}
#dashboard-container-dark .card-block-dark {
  position: relative;
  cursor: pointer;
  background-color: #3888ff;
  opacity: 1;
  background-image: linear-gradient(rgba(2, 4, 30, 0.24), rgba(2, 4, 30, 0.24)), linear-gradient(248deg, #297fff, #ae00ff);
  padding: 0.1rem;
}
#dashboard-container-dark .card-block-dark .bottom-line {
  padding: 8px 0px 0px 0px;
  background-color: var(--ffff);
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-radius: 0px 0px 35px 35px;
  visibility: hidden;
}
#dashboard-container-dark .card-block-dark .dark-card {
  background-color: rgba(7, 9, 36, 0.9529411765);
  background-image: linear-gradient(rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
  border-radius: 14px;
  padding: 10px;
}
#dashboard-container-dark .card-block-dark .dark-card:hover {
  background-image: linear-gradient(rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.09));
}

.react-tooltip.dark {
  background-color: var(--2b4e) !important;
  color: var(--ffff) !important;
  border: 1px solid rgba(255, 255, 255, 0.3294117647);
}

.react-tooltip.dark .react-tooltip-arrow {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,cAAA;AACF;AAAE;EACE,kBAAA;EACA,eAAA;EACA,6BAAA;AAEJ;AADI;EACE,wBAAA;EACA,6BAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;AAGN;AAAE;EACE,6BAAA;EACA,yDAAA;AAEJ;AADI;EACE,mBAAA;AAGN;;AAEA;EACE,YAAA;EACA,2CAAA;EACA,wCAAA;EACA,6BAAA;EACA,UAAA;EACA,yBAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;AACF;;AACA;EACE,aAAA;AAEF;;AAAA;EACE,qBAAA;AAGF;;AACE;EAEE,sBAAA;EAEA,wBAAA;EAEA,yBAAA;AAEJ;;AAEA;EACE,0BAAA;EACA,cAAA;AACF;AAAE;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;EACA,wHAAA;EAKA,eAAA;AAFJ;AAGI;EACE,wBAAA;EACA,6BAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;AADN;AAGI;EACE,8CAAA;EACA,uFAAA;EAIA,mBAAA;EACA,aAAA;AAJN;AAMI;EACE,uFAAA;AAJN;;AAYA;EACE,wCAAA;EACA,6BAAA;EACA,mDAAA;AATF;;AAYA;EACE,aAAA;AATF","sourcesContent":["#dashboard-container {\r\n  height: calc(100vh - 80px);\r\n  overflow: auto;\r\n  .card-block {\r\n    position: relative;\r\n    cursor: pointer;\r\n    border: 1px solid var(--dee3);\r\n    .bottom-line {\r\n      padding: 8px 0px 0px 0px;\r\n      background-color: var(--56ff);\r\n      position: absolute;\r\n      left: 0;\r\n      bottom: 0;\r\n      width: 100%;\r\n      border-radius: 0px 0px 35px 35px;\r\n      visibility: hidden;\r\n    }\r\n  }\r\n  .card-block:hover {\r\n    border: 1px solid var(--56ff);\r\n    box-shadow: 0px 20px 40px 0px #0000000a;\r\n    .bottom-line {\r\n      visibility: visible;\r\n    }\r\n  }\r\n}\r\n\r\n.react-tooltip {\r\n  z-index: 999;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 9px 29px;\r\n  background-color: var(--ffff) !important;\r\n  color: var(--2749) !important;\r\n  opacity: 1;\r\n  border: 1px solid #efefef;\r\n  max-width: 350px !important;\r\n  padding: 16px !important;\r\n  border-radius: 10px !important;\r\n}\r\n.react-tooltip-arrow {\r\n  display: none;\r\n}\r\n.core-styles-module_show__Nt9eE {\r\n  opacity: 1 !important;\r\n}\r\n\r\n.switch-block:hover {\r\n  .react-tooltip {\r\n    -webkit-animation-name: zoomIn;\r\n    animation-name: zoomIn;\r\n    -webkit-animation-duration: 0.3s;\r\n    animation-duration: 0.3s;\r\n    -webkit-animation-fill-mode: both;\r\n    animation-fill-mode: both;\r\n  }\r\n}\r\n\r\n#dashboard-container-dark {\r\n  height: calc(100vh - 80px);\r\n  overflow: auto;\r\n  .card-block-dark {\r\n    position: relative;\r\n    cursor: pointer;\r\n    background-color: #3888ff;\r\n    opacity: 1;\r\n    background-image: linear-gradient(\r\n        rgba(2, 4, 30, 0.24),\r\n        rgba(2, 4, 30, 0.24)\r\n      ),\r\n      linear-gradient(248deg, #297fff, #ae00ff);\r\n    padding: 0.1rem;\r\n    .bottom-line {\r\n      padding: 8px 0px 0px 0px;\r\n      background-color: var(--ffff);\r\n      position: absolute;\r\n      left: 0;\r\n      bottom: 0;\r\n      width: 100%;\r\n      border-radius: 0px 0px 35px 35px;\r\n      visibility: hidden;\r\n    }\r\n    .dark-card {\r\n      background-color: #070924f3;\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.03),\r\n        rgba(255, 255, 255, 0.03)\r\n      );\r\n      border-radius: 14px;\r\n      padding: 10px;\r\n    }\r\n    .dark-card:hover {\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.09),\r\n        rgba(255, 255, 255, 0.09)\r\n      );\r\n    }\r\n  }\r\n}\r\n\r\n.react-tooltip.dark {\r\n  background-color: var(--2b4e) !important;\r\n  color: var(--ffff) !important;\r\n  border: 1px solid #ffffff54;\r\n}\r\n\r\n.react-tooltip.dark .react-tooltip-arrow {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
